import api from '../utils/Api';
import {
  FETCH_NSA_REPORT_LIST, SAVE_NSA_RESULT_DATA, FETCH_STARTUP_APPLICATION_LIST,
  UPDATE_NSA_REPORT_LIST,
  LAST_GENERATED_REPORT_HISTORY,
  NSA_TAG_REPORT_HISTORY,
  FETCH_REPORT_LIST,LIST_OF_EVENT,GENERATE_INTERNATIONAL_EVENT_ID,FETCH_COUNTRY_LIST,FETCH_INTERNATIONAL_REPORT_LIST,UPDATE_INTERNATIONAL_REPORT_LIST,HISTORY_INTERNATIONAL_TAG,GET_EVENT_NAME,HISTORY_CORPORATE_TAG,UPDATE_CORPORATE_LIST,FETCH_ALL_USER_CORPORATE,FETCH_ALL_CORPORATE_NAME,FETCH_ALL_CORPORATE_EVENT_NAME,GENRATE_CORPORATE_EVENT_ID,CORPORATE_EVENT_LIST,GENERATE_MINISTRY_EVENT_ID, FETCH_LIST_OF_MINISTRY_REPORT, FETCH_MINISTRY_NAMES, FETCH_MINISTRY_EVENT_NAMES, LAST_UPDATED_MINISTRY_NAMES, UPDATE_MINISTRY_TAG, FETCH_MINISTRY_EVENT_NAMES_LIST
} from "../../constants/ApplicationUrl";
import { fetchNSAReport, fetchSeedfundResult, saveNsaResult, fetchInternationalResult, fetchEventsList, SET_EVENT_TOTAL_COUNT, SET_EVENT_PAGE_INDEX } from "../../constants/actionConstants";
import { isLoading } from '../../constants/actionConstants';


export const getNSAReportList = ({ sortColumn, sortOrder, pageSize, pageIndex, query }) => (dispatch) => {
    dispatch(isLoading(true));
    return api.POST(FETCH_REPORT_LIST, { sortColumn, sortOrder, pageSize, pageIndex, query })
      .then((data) => {
        if (data && data.data) {
          dispatch(fetchNSAReport(data.data));
        }
        dispatch(isLoading(false));
      })
  }

  export const saveNsaResultData = ({ dippNumber,result }) => (dispatch) => {
    dispatch(isLoading(true));
    return api.GET(`${SAVE_NSA_RESULT_DATA}/${dippNumber}/${result}`)
      .then((data) => {
        dispatch(isLoading(false));
        if (data && data.data && data.data.status) {
          dispatch(saveNsaResult(data.data));
          return data.data
        }
        else{
          dispatch(saveNsaResult(data.data));
          return data.data
        }
      
      })
  }

  export const doDownloadResultList = (params) => (dispatch) => {
    dispatch(isLoading(true));
    return api.DOWNLOADDATA(FETCH_STARTUP_APPLICATION_LIST, params)
      .then((response) => {
        const { data = "" } = response;
        dispatch(isLoading(false));
        return data;
      }).catch(e => {
        dispatch(isLoading(false))
        return "";
      })
  }

  export const getSeedfundReportList = ({ sortColumn, sortOrder, pageSize, pageIndex, query }) => (dispatch) => {
    dispatch(isLoading(true));
    return api.POST(FETCH_REPORT_LIST, { sortColumn, sortOrder, pageSize, pageIndex, query })
      .then((data) => {
        if (data && data.data) {
          dispatch(fetchSeedfundResult(data.data));
        }
        dispatch(isLoading(false));
      })
  }
  export const updateNSAReportList = ({ query, params }) => (dispatch) => {
    dispatch(isLoading(true));
    return api.POST(`${UPDATE_NSA_REPORT_LIST}/${params}`, query )
      .then((response) => {
        const { data = "" } = response;
        if (data) {
          dispatch(isLoading(false));
          return data;
        }
        dispatch(isLoading(false));
      }).catch(e => {
        dispatch(isLoading(false));
      })
  }

  export const lastGeneratedReportHistory = (params) => (dispatch) => {
    return api.GET(NSA_TAG_REPORT_HISTORY).then((response)=>{
      const { data = "" } = response;
        if(data && data.status)
        {
            return data.data;
        }
    }).catch(e =>{
        return Promise.reject(e);
    })
}

export const ListOfEvent = (params) => async (dispatch) => {
  try {
    dispatch(isLoading(true));

    const response = await api.POST(LIST_OF_EVENT, params);

    if (response?.data?.data) {
      dispatch(fetchEventsList(response.data.data));
      dispatch({
        type: SET_EVENT_TOTAL_COUNT,
        payload: response.data.recordsFiltered,
      })
      dispatch({
        type: SET_EVENT_PAGE_INDEX,
        payload: response.data.pageIndex,
      })
    } else {
      console.warn("No data found in response");
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching events list:", error);

    return Promise.reject(error);
  } finally {
    dispatch(isLoading(false));
  }

}

export const GenerateInternatinalEventId = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(GENERATE_INTERNATIONAL_EVENT_ID, params)
    .then((response) => {
      const { data = "" } = response;
      dispatch(isLoading(false));
      return data;
    }).catch(e => {
      dispatch(isLoading(false))
    })
}

export const CountryName = () => () => {
  return api.GET(FETCH_COUNTRY_LIST).then((response)=>{
    const data   = response;
          return data.data
  }).catch(e =>{
      return Promise.reject(e);
  })
}

export const getInternationalReportList = ({ sortColumn, sortOrder, pageSize, pageIndex, query }) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(FETCH_INTERNATIONAL_REPORT_LIST, { sortColumn, sortOrder, pageSize, pageIndex, query })
    .then((data) => {
      if (data && data.data) {
        dispatch(fetchInternationalResult(data.data));
      }
      dispatch(isLoading(false));
    })
}

export const updateInternationalReportList = ({ query, params }) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(`${UPDATE_INTERNATIONAL_REPORT_LIST}/${params}`, query )
    .then((response) => {
      const { data = "" } = response;
      if (data) {
        dispatch(isLoading(false));
        return data;
      }
      dispatch(isLoading(false));
    }).catch(e => {
      dispatch(isLoading(false));
    })
}

export const HistoryInternationalTag = () =>{
  return api.GET(HISTORY_INTERNATIONAL_TAG).then((response)=>{
    const data = response;
      return data.data
  }).catch(e =>{
      return Promise.reject(e);
  })
}

export const EventName = () => () => {
  return api.GET(GET_EVENT_NAME).then((response)=>{
    const data   = response;
          return data.data
  }).catch(e =>{
      return Promise.reject(e);
  })
}

export const GenerateCorporateEventId = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(GENRATE_CORPORATE_EVENT_ID, params)
    .then((response) => {
      const { data = "" } = response;
      dispatch(isLoading(false));
      return data;
    }).catch(e => {
      dispatch(isLoading(false))
    })
}

export const FetchHistoryCorporateTag = () =>{
  return api.GET(HISTORY_CORPORATE_TAG).then((response)=>{
    const data = response;
      return data.data
  }).catch(e =>{
      return Promise.reject(e);
  })
}

export const updateCorporateReportList = ({ query, params }) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(`${UPDATE_CORPORATE_LIST}/${params}`, query )
    .then((response) => {
      const { data = "" } = response;
      if (data) {
        dispatch(isLoading(false));
        return data;
      }
      dispatch(isLoading(false));
    }).catch(e => {
      dispatch(isLoading(false));
    })
}

export const GenerateMinistryEventId = (params) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(GENERATE_MINISTRY_EVENT_ID, params)
    .then((response) => {
      const { data = "" } = response;
      dispatch(isLoading(false));
      return data;
    }).catch(e => {
      dispatch(isLoading(false))
    })
}

export const fetchMinistryNames = () => () => {
  return api.GET(FETCH_MINISTRY_NAMES).then((response) => {
    const data = response;
    return data.data
  }).catch(e => {
    return Promise.reject(e);
  })
}
export const fetchMinistryEventNames = () => () => {
  return api.GET(FETCH_MINISTRY_EVENT_NAMES).then((response) => {
    const data = response;
    return data.data
  }).catch(e => {
    return Promise.reject(e);
  })
}

export const fetchLastUpdatedMinistryNames = () => {
  return api.GET(LAST_UPDATED_MINISTRY_NAMES).then((response) => {
    const data = response;
    return data.data
  }).catch(e => {
    return Promise.reject(e);
  })

}
export const updateMinistryList = ({ query, params }) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(`${UPDATE_MINISTRY_TAG}/${params}`, query)
    .then((response) => {
      const { data = "" } = response;
      if (data) {
        dispatch(isLoading(false));
        return data;
      }
      dispatch(isLoading(false));
    }).catch(e => {
      dispatch(isLoading(false));
    })
}

export const getCorporateReportList = ({ sortColumn, sortOrder, pageSize, pageIndex, query }) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(FETCH_ALL_USER_CORPORATE, { sortColumn, sortOrder, pageSize, pageIndex, query })
    .then((data) => {
      if (data && data.data) {
        dispatch(fetchInternationalResult(data.data));
      }
      dispatch(isLoading(false));
    })
}

export const getMinistryList = ({ sortColumn, sortOrder, pageSize, pageIndex, query }) => (dispatch) => {
  dispatch(isLoading(true));
  return api.POST(FETCH_MINISTRY_EVENT_NAMES_LIST, { sortColumn, sortOrder, pageSize, pageIndex, query })
    .then((data) => {
      if (data && data.data) {
        dispatch(fetchInternationalResult(data.data));
      }
      dispatch(isLoading(false));
    })
}

export const AllCorporateTag = () => () => {
  return api.GET(FETCH_ALL_CORPORATE_NAME).then((response)=>{
    const data   = response;
          return data.data
  }).catch(e =>{
      return Promise.reject(e);
  })
}

export const ALLCorporateEventName = () => () => {
  return api.GET(FETCH_ALL_CORPORATE_EVENT_NAME).then((response)=>{
    const data   = response;
          return data.data
  }).catch(e =>{
      return Promise.reject(e);
  })
}

export const CorporateListOfEvent = (params) => async (dispatch) => {
  try {
    dispatch(isLoading(true));

    const response = await api.POST(CORPORATE_EVENT_LIST, params);

    if (response?.data?.data) {
      dispatch(fetchEventsList(response.data.data));
      dispatch({
        type: SET_EVENT_TOTAL_COUNT,
        payload: response.data.recordsFiltered,
      })
      dispatch({
        type: SET_EVENT_PAGE_INDEX,
        payload: response.data.pageIndex,
      })
    } else {
      console.warn("No data found in response");
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching events list:", error);

    return Promise.reject(error);
  } finally {
    dispatch(isLoading(false));
  }

}

export const ListOfMinistry = (params) => async (dispatch) => {
  try {
    dispatch(isLoading(true));

    const response = await api.POST(FETCH_LIST_OF_MINISTRY_REPORT, params);

    if (response?.data?.data) {
      dispatch(fetchEventsList(response.data.data));
      dispatch({
        type: SET_EVENT_TOTAL_COUNT,
        payload: response.data.recordsFiltered,
      })
      dispatch({
        type: SET_EVENT_PAGE_INDEX,
        payload: response.data.pageIndex,
      })
    } else {
      console.warn("No data found in response");
    }
    return response.data;
  } catch (error) {
    console.error("Error fetching events list:", error);

    return Promise.reject(error);
  } finally {
    dispatch(isLoading(false));
  }

}